import { DataTypeEnum } from "../_common/enum/dataType.enum";
import { API_URL } from "../_config/config.const";
import { getBody } from "../_helpers/body.helper";
import { handleResponse } from "../_helpers/handleResponse.helper";
import { getHeader } from "../_helpers/header.helper";

const API_NAME = "dropdown";

export type ParentItem = { propertyName: string; value: number | string };
export type ParentId = number | string | ParentItem[];

export const dropdownService = {
    fetchData,
    fetchFormDataMultiple,
    createEntityFormFieldValueType,
};

export function isParentArray(x: ParentId): x is ParentItem[] {
    return Array.isArray(x);
}

function fetchData(dataTypeEnum: DataTypeEnum, parentId?: number, method: string = 'GET') {
    const requestOptions = { method, headers: getHeader() };
    const endpoint = `get${dataTypeEnum}`;

    const url = `${API_URL}/${API_NAME}/${endpoint}/?parentId=${parentId || ""}`;

    return fetch(url, requestOptions).then(handleResponse);
}

function fetchFormDataMultiple(dataTypeEnum: DataTypeEnum, parentId?: ParentId, method: string = 'GET') {
    const requestOptions = { method, headers: getHeader() };
    const endpoint = `get${dataTypeEnum}`;

    let query = ``

    if (!!parentId && isParentArray(parentId)) {
        // parentId is ParentItem[] here
        query = parentId.map((m, index) => `parentIds[${index}].propertyName=${m.propertyName}&parentIds[${index}].value=${m.value}`).join("&");

    } else {
        query = `parentId=${parentId || ""}`
    }

    const url = `${API_URL}/${API_NAME}/${endpoint}/?${query}`;

    return fetch(url, requestOptions).then(handleResponse);
}

function createEntityFormFieldValueType(name: string) {
    const requestOptions = {
        method: "POST",
        headers: getHeader(),
        body: getBody({ name }),
    };

    return fetch(`${API_URL}/entityFormFieldValueType/create`, requestOptions).then(handleResponse);
}


